import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Common/Button";
import Input from "../../../components/Common/Input/Input";
import mainContext from "../../../context/mainContext";
import { validate } from "../../Signup/Signup/validate";
import styles from "./style.module.css";
import dataContext from "../../../context/dataContext";

function BookInfo({ from }) {
  const { header } = useContext(mainContext);
  const { userDetails } = useContext(dataContext);
  const navigate = useNavigate();
  const [valid, setValid] = useState([]);
  const [renderer, setRenderer] = useState(false);
  const [bookList, setBookList] = useState(() => userDetails.TR.length > 0 ? filterAndSortBooks(userDetails.TR) : []);
  const [selectedBook, setSelectedBook] = useState('');
  const [customBookName, setCustomBookName] = useState('');
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [genre, setGenre] = useState('');
  const [LPM, setLPM] = useState("");
  const [animate, setAnimate] = useState(false);

  const calculateAverageLPM = () => {
    if (bookList.length === 0) return 30;
    const totalLPM = bookList.reduce((sum, book) => sum + book.lastLPM, 0);
    return Math.round(totalLPM / bookList.length);
  };

  const getLPMMessage = () => {
    // if (showCustomInput) {
    return bookList.length === 0 ?
      "Initial reading rate:" :
      selectedBook ? <div>Reading Rate from your last<br></br> JUST RIGHT Rate:</div> :
        "Reading rate based on your average:";

  };


  useEffect(() => {
    if (bookList.length > 0 && from != "freestyle" && showCustomInput == false) {
      // Get the most recent book (first in the sorted list)
      const mostRecentBook = bookList[0];

      // Set the book
      setSelectedBook(mostRecentBook.bookName);

      // Set its associated data
      setGenre(mostRecentBook.genre);
      setLPM(mostRecentBook.lastLPM);
    }
  }, [bookList, showCustomInput]); // Depends on bookList

  useEffect(() => {
    if (from == "freestyle") {

      header.setPageName(`SET RATE`);
    } else {
      header.setPageName(`Book Info`.toUpperCase());
    }


    // If coming from freestyle and no books, navigate automatically
    if (from === "freestyle") {
      if (bookList.length === 0) {
        setLPM(30)

      } else {

        setLPM(calculateAverageLPM())
      }
      // navigate("/freestyle/set-rate", {
      //   state: {
      //     bookName: "",
      //     genre: "",
      //     newBook: true,
      //     chosenLpm: 20
      //   }
      // });
    }
    setTimeout(() => {
      setRenderer(true)
    }, [200]);
    if (from == "freestyle" && bookList.length == 0) {
      navigate("/freestyle/set-rate", {
        state: { newBook: null, chosenLpm: LPM ? LPM : 30, from }
      });

    }
    return () => header.setPageName(``);
  }, []);

  const handleSubmit = async (e) => {

    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const body = {
      bookName: showCustomInput ? customBookName : formData.get("bookName"),
      genre: formData.get("genre"),
    };

    const fieldsToValidate = from === "freestyle" ?
      { bookName: body.bookName } :
      { bookName: body.bookName, genre: body.genre };

    const checkResult = validate(fieldsToValidate);
    from !== "freestyle" && setValid(checkResult);

    if (checkResult.length && from !== "freestyle") return;
    if (from === "freestyle") {
      setAnimate(true);
    }

    try {
      body.bookName = body.bookName?.toLowerCase().trim();
      body.genre = body.genre ? body.genre.toLowerCase().trim() : "uknown";
      let newBook = true;
      let currentBook = null;

      if (userDetails.TR.length > 0) {
        const filteredBooks = bookList.filter(book => book.bookName === body.bookName);
        currentBook = filteredBooks.length > 0 ? filteredBooks[0] : false;
        if (currentBook) {
          newBook = false;
        }
        localStorage.Epage = currentBook?.lastPageTheUserRead || "";
      }

      if (newBook) {
        localStorage.Epage = "";
      }
      localStorage.bookname = body.bookName;
      localStorage.genre = body.genre;

      const chosenLpm = showCustomInput ? calculateAverageLPM() : LPM ? LPM : 30;

      if (from === "freestyle") {
        setTimeout(() => {
          navigate("/freestyle/set-rate", {
            state: { ...body, newBook, chosenLpm, from }
          });
        }, 500);
      } else {
        navigate("/freestyle/set-rate", {
          state: { ...body, newBook, chosenLpm, from: "pushup start" }
        });
        // navigate("/train-reading/pushup", {
        //   state: { ...body, newBook, chosenLpm, from:"pushup start" }
        // });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBookChange = (e) => {
    const selectedBookName = e.target.value;
    if (selectedBookName === "new" && from !== "freestyle") {
      setShowCustomInput(true);
      setSelectedBook("");
      setGenre("");
      setLPM(calculateAverageLPM());
      setCustomBookName("");
    } else {
      setShowCustomInput(false);
      setSelectedBook(selectedBookName);
      const book = bookList.find(book => book.bookName === selectedBookName);
      if (book) {
        setGenre(book.genre);
        setLPM(book.lastLPM);
      } else {
        setGenre('');
        setLPM("");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.bookInfo} style={window.buildType === "iPhone" ? { minHeight: "85dvh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start", marginTop: "0" } : { flexGrow: 1 }}>
      {LPM > 0 && from == "freestyle" && (
        <>
          <div className={styles.flexfreestyle}>
            <div className={styles.center}>
              <div className={styles.getLPMMessage}>Starting Rate</div>
              <div className={animate ? styles.exit : styles.squareButton}>
                <div className={styles.rapid}>{LPM}</div>
              </div>
            </div>
          </div>
          {bookList.length > 0 && <div className={styles.getLPMMessage} style={{ marginBottom: "2rem" }}>Choose a different starting rate:</div>}

        </>
      )}


      <div className={styles.selectContainer}>
        {from != "freestyle" && bookList.length > 0 && !showCustomInput && <label htmlFor="bookSelect">Book Title</label>}
        {!showCustomInput ? (
          bookList.length > 0 ?
            <select
              id="bookSelect"
              name="bookName"
              value={selectedBook}
              onChange={handleBookChange}
              className={`${styles.select} ${!valid.includes("bookName") ? "" : styles.invalid}`}
            >
              <option value="" disabled hidden>{from == "freestyle" ? "SELECT A RATE" : "SELECT A BOOK"}</option>
              {bookList.map((book, index) => (
                <option key={index} value={book.bookName}>
                  {`${book.bookName} (${book.lastLPM} LPM)`}
                </option>
              ))}
              {from !== "freestyle" && <option style={{ color: "green" }} value="new">+ Add A New Book</option>}
            </select>
            :
            <Input
              type="text"
              name="bookName"
              value={selectedBook}
              onChange={(e) => setSelectedBook(e.target.value)}
              valid={!valid.includes("bookName")}
              legend="New Book Title"
            />

        ) : (
          <div className={styles.customInputContainer}>
            <Input
              type="text"
              name="customBook"
              value={customBookName}
              onChange={(e) => setCustomBookName(e.target.value)}
              valid={!valid.includes("bookName")}
              legend="New Book Title"
            />
            <button
              type="button"
              onClick={() => {
                setShowCustomInput(false);
                setSelectedBook("");
              }}
              className={styles.cancelButton}
            >
              Cancel
            </button>
          </div>
        )}
      </div>

      {from !== "freestyle" && (
        <Input
          legend="Genre"
          type="text"
          value={genre}
          name="genre"
          valid={!valid.includes("genre")}
          onChange={(e) => setGenre(e.target.value)}
        />
      )}

      {LPM > 0 && from != "freestyle" && (
        <div className={styles.flex}>
          <div className={styles.center}>
            <div className={styles.getLPMMessage}>{getLPMMessage()}</div>
            <div className={animate ? styles.exit : styles.squareButton}>
              <div className={styles.rapid}>{LPM}</div>
            </div>
          </div>
        </div>
      )}

      <div className="btnHolder">
        <Button title="NEXT" height="50px" fontColor={"white"} width={"85%"} />
      </div>
      {renderer && <div></div>}
    </form>
  );
}

export default BookInfo;

function filterAndSortBooks(inputArray) {
  let books = inputArray;
  books.sort((a, b) => new Date(b.date) - new Date(a.date));
  let uniqueBooks = {};
  books.forEach(book => {
    let bookNameLower = book.bookName.trim().toLowerCase();
    if (!uniqueBooks[bookNameLower]) {
      let lastPageTheUserRead = null;
      if (book.answers.level && book.answers.level[book.answers.level.length - 1]["6"]) {
        lastPageTheUserRead = book.answers.level[book.answers.level.length - 1]["6"];
      } else if (book.answers.pushUp && book.answers.pushUp[book.answers.pushUp.length - 1]["6"]) {
        lastPageTheUserRead = book.answers.pushUp[book.answers.pushUp.length - 1]["6"];
      }
      uniqueBooks[bookNameLower] = {
        bookName: bookNameLower,
        genre: book.genre.trim().toLowerCase(),
        lastPageTheUserRead: lastPageTheUserRead,
        lastLPM: book.value
      };
    }
  });

  return Object.values(uniqueBooks);
}